<template>
    <div class="addFollowUpBox">
        <div class="title">
            <p></p>
            <h4>添加跟进记录</h4>
        </div>
        <div class="content">
            <el-form ref="argument" :model="argument">
                <el-form-item prop="genjin_type" label="跟进类型"  :rules="{ required: true}">
                    <el-select
                        v-model="argument.genjin_type"
                        class="filter-item common-r"
                        placeholder="请选择跟进类型"
                    >
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="remark" label="跟进记录" :rules="{ required: true}">
                    <el-input v-model="argument.remark" placeholder="请输入跟进记录" type="textarea"></el-input>
                </el-form-item>
                <el-form-item prop="remark" label="跟进记录文件">
                    <el-upload
                        ref='upload'
                        class="inline"
                        :limit="1"
                        :on-preview="handlePreview"
                        :on-remove="(file, fileList) => {handleRemove(file, fileList, upload_data.doc_type)}"
                        :on-success="handleSuccess"
                        :on-exceed="handleExceed"
                        accept=".jpg,.jpeg,.png,.mp3,.wav"
                        :headers="headers"
                        :action="url"
                        name="file"
                        :data="upload_data"
                        :file-list="application"
                    >
                        <el-button class="custom" type="primary">
                            上传
                        </el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
        <div class="save" style="margin: auto;">
            <el-button  class="save" @click="save" type="primary">保存</el-button>
        </div>
    </div>
</template>

<script>
import { addFollowUpRecord } from '@/api/callCenter';
import bus from '../../../components/common/bus';

export default {
    name: 'addFollowUp',
    data(){
        return{
            url:process.env.VUE_APP_BASE_API+'/api/upload_zuoxi_genjin_file',
            headers:{
                "Authorization": sessionStorage.getItem("token"),
                "Comid": sessionStorage.getItem("shenfen"),
                "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
            },
            upload_data:{

            },
            application:[],
            argument:{
                id:'',
                genjin_type:'',
                remark:'',
                psd_code:''
            },
            statusList:[
                {
                    value: '1',
                    label: '电话'
                },
                {
                    value: '2',
                    label: '微信'
                },
                {
                    value: '3',
                    label: 'QQ'
                },
                {
                    value: '4',
                    label: '短信'
                },
                {
                    value: '5',
                    label: '邮件'
                },
                {
                    value: '6',
                    label: '拜访'
                },
            ],
        }
    },
    methods:{
        //点击文件列表事件
        handlePreview(file){
            if (file.all_url){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.all_url);
            }else if (file.response){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = file.response.data.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(file.response.data.all_url);
            }
        },
        // 移除
        handleRemove(){

        },
        //上传成功
        handleSuccess(response, file, fileList){
            if (response.code == 200){
                this.argument.psd_code=response.data.psd_code
            }else {
                this.$message.error(response.msg);
            }
        },
        //限制条数
        handleExceed(files, fileList){
            if (fileList.length>=1){
                this.$message.error('只能上传1个文件');
            }
        },
        // 保存
        save(){
            if (Object.entries(this.argument).some(([key, value]) => key !== 'psd_code' && value === '')) {
                this.$message.error('请填写完整信息');
                return;
            }else {
                addFollowUpRecord(this.argument).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        bus.$emit('close_current_tags')
                        this.$router.push({
                            path:'/clueList',
                        })
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        }
    },
    created(){
        this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
        this.argument.id = this.$route.query.id;
    },
}
</script>

<style scoped lang="scss">
    .addFollowUpBox{
        background-color: #fff;
        padding: 30px;
        border-radius: 5px;
    }
    .title {
        color: #409eff;
        display: flex;
        align-items: center;
    }

    .title > p {
        margin-right: 10px;
        width: 5px;
        height: 18px;
        background-color: #409eff;
    }
    .content{
        margin: 20px 0px;
    }
    .el-select{
        width: 30%;
    }
    .el-textarea{
        width: 30%;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    ::v-deep .el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .save{
        width: 120px;
        height: 40px;
        border-radius: 5px;
    }
    .fileContent>p{
        width: 150px;
        color: #666666;
        font-size: 14px;
    }
    ::v-deep .el-upload-list{
        /*width: 150px;*/
        display: flex;
        align-items: flex-end;
    }
</style>